import { Heart, Share2, Sparkles } from "lucide-react";

const items = [
  {
    icon: Heart,
    title: "The Reimbursement Trap",
    body: "No more chasing friends for money. Friends pay directly into the same order flow and Splitkart handles the shared math.",
  },
  {
    icon: Sparkles,
    title: "Goodbye Price Shock",
    body: "Turn premium items into affordable shared costs. A high-ticket order suddenly feels achievable when the amount is split across friends.",
  },
  {
    icon: Share2,
    title: "Built-in Viral Growth",
    body: "Every split-link becomes a zero-cost referral touchpoint, bringing new shoppers straight back to the merchant storefront.",
  },
];

export function ProblemSolution() {
  return (
    <section className="section">
      <div className="container-tight">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Why Splitkart</span>
          <h2 className="mt-5 text-3xl font-bold md:text-5xl">Social payments, not buy-now-pay-later.</h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Splitkart helps merchants unlock higher-value orders without introducing debt, interest, or reimbursement friction.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="group rounded-2xl border border-border bg-card p-8 transition-all hover:border-primary/30 hover:shadow-elevated"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent text-primary transition-transform group-hover:scale-110">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="mt-6 text-xl font-bold">{title}</h3>
              <p className="mt-3 text-muted-foreground">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
